import { render, staticRenderFns } from "./ModalIntegrarRepasseUnico.vue?vue&type=template&id=efd3948a"
import script from "./ModalIntegrarRepasseUnico.vue?vue&type=script&lang=ts"
export * from "./ModalIntegrarRepasseUnico.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports